/* MAGVITA — product page behavior
   - Gallery: thumbnail swap via event delegation, scroll-snap thumbnail strip
   - Quantity stepper
   - Sticky ATC reveal via IntersectionObserver
   - Dynamic Add to Cart: loading + success states, cooperates with UpCart */
(function () {
  'use strict';

  /* gallery is now inline-onclick in the section markup — no JS needed */

  /* ---------- quantity stepper ---------- */
  function initQuantity() {
    var wrap = document.querySelector('[data-mv-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-mv-qty-minus]');
    var plus = wrap.querySelector('[data-mv-qty-plus]');
    function clamp(v) { return Math.max(1, parseInt(v, 10) || 1); }
    if (minus) minus.addEventListener('click', function () {
      var v = clamp(input.value); input.value = v - 1 < 1 ? 1 : v - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = clamp(input.value) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (input) input.addEventListener('change', function () { input.value = clamp(input.value); });
    if (input) input.addEventListener('change', function () { var hid = document.querySelector('[data-mv-form-qty]'); if (hid) hid.value = clamp(input.value); });
  }

  /* ---------- dynamic Add to Cart with state transitions ---------- */
  function setAtcState(btn, state) {
    btn.classList.remove('is-loading', 'is-success');
    if (state === 'loading') btn.classList.add('is-loading');
    else if (state === 'success') btn.classList.add('is-success');
  }

  /* ---------- open the NATIVE theme cart drawer (Shrine/Dawn style) ---------- */
  function mvOpenDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var dp = new DOMParser();
        var cd = document.querySelector('cart-drawer');
        if (data['cart-drawer'] && cd) {
          var nd = dp.parseFromString(data['cart-drawer'], 'text/html');
          var fresh = nd.querySelector('.drawer__inner');
          var cur = cd.querySelector('.drawer__inner');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        }
        if (data['cart-icon-bubble']) {
          var nb = dp.parseFromString(data['cart-icon-bubble'], 'text/html');
          var fb = nb.querySelector('#cart-icon-bubble');
          var cb = document.querySelector('#cart-icon-bubble');
          if (fb && cb) cb.innerHTML = fb.innerHTML;
        }
        if (cd) {
          cd.classList.remove('is-empty');
          cd.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
        }
      });
  }

  function addToCart(variantId, quantity, button) {
    if (!variantId) return;
    setAtcState(button, 'loading');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed (' + res.status + ')');
        return res.json();
      })
      .then(function () {
        setAtcState(button, 'success');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          mvOpenDrawer().catch(function () { window.location.href = '/cart'; });
          setAtcState(button, 'idle');
          button.disabled = false;
        }, 450);
      })
      .catch(function (err) {
        console.error('[MV] add to cart error:', err);
        setAtcState(button, 'idle');
        button.disabled = false;
        /* fallback: navigate to cart page so the user isn't stuck */
        if (confirm('Add to cart failed. Open the cart page instead?')) {
          window.location.href = '/cart';
        }
      });
  }

  function initAtcButtons() {
    var buttons = document.querySelectorAll('[data-mv-atc]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var variantId = btn.getAttribute('data-variant-id');
        var qtyInput = document.querySelector('[data-mv-qty] input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        addToCart(variantId, qty, btn);
      });
    });
  }

  /* ---------- header cart icon ----------
     Behavior:
     - If UpCart (or another drawer cart app) is installed and listening:
       intercept the click, fire the open event, prevent navigation to /cart.
     - If no drawer cart app: link falls through and navigates to /cart page.
     This guarantees the cart always opens one way or another. */
  function initCartTrigger() {
    var triggers = document.querySelectorAll('[data-mv-cart-trigger]');
    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        mvOpenDrawer().catch(function () { window.location.href = '/cart'; });
      });
    });
  }

  function init() {
    initQuantity();
    initAtcButtons();
    initCartTrigger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
